import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CountUp } from './CountUp';

const reduce = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

/** Loops the pre-approval demo: ring fills to 810, amount counts up to 40 000 $. */
export const PreApprovalPhone = () => {
  const { t } = useTranslation();
  const [cycle, setCycle] = useState(0);
  useEffect(() => {
    if (reduce()) return undefined;
    const id = setInterval(() => setCycle((c) => c + 1), 7000);
    return () => clearInterval(id);
  }, []);
  return (
    <div className="bg-white rounded-[20px] shadow-lg w-[130px] md:w-[150px] overflow-hidden border-[4px] border-slate-200" data-testid="hero-preapproval-phone">
      <div className="bg-slate-200 h-5 md:h-6 flex items-center justify-center">
        <div className="w-12 md:w-16 h-2.5 md:h-3 bg-slate-300 rounded-full" />
      </div>
      <div key={cycle} className="p-3 md:p-4 flex flex-col items-center bg-white">
        <p className="text-green-500 font-bold text-xs md:text-sm mb-1 text-center phone-pop">{t('creditWidget.congratulations')}</p>
        <p className="text-slate-500 text-[10px] md:text-xs mb-1 text-center">{t('creditWidget.preApproved')}</p>
        <p className="text-slate-500 text-[10px] md:text-xs mb-3 md:mb-4 text-center">
          {t('creditWidget.upTo')} <CountUp value="40000" duration={1800} className="font-bold text-slate-900 text-sm md:text-base whitespace-nowrap" format={(n) => `${Math.round(n).toLocaleString('fr-CA')}\u00a0$`} data-testid="hero-preapproval-amount" />
        </p>
        <div className="relative w-20 h-20 md:w-24 md:h-24 mx-auto mb-2 md:mb-3">
          <svg className="w-full h-full transform -rotate-90" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="40" stroke="#e5e7eb" strokeWidth="6" fill="none" />
            <circle cx="50" cy="50" r="40" stroke="#22c55e" strokeWidth="6" fill="none" strokeDasharray="251" strokeDashoffset="35" strokeLinecap="round" className="score-ring" />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <CountUp value="810" duration={1600} className="text-xl md:text-2xl font-bold text-slate-900" data-testid="hero-preapproval-score" />
            <span className="text-[7px] md:text-[8px] text-green-500 font-bold tracking-wider">{t('creditWidget.excellent')}</span>
          </div>
        </div>
        <div className="space-y-1.5 px-2 w-full">
          <div className="h-1 md:h-1.5 bg-[#3b82f6] rounded-full w-full bar-grow" />
          <div className="h-1 md:h-1.5 bg-slate-200 rounded-full w-2/3" />
        </div>
      </div>
    </div>
  );
};

/** Typed-out rotating examples for an empty search box placeholder. */
export const useTypingPlaceholder = (fallback, words = ['Camry', 'X5', 'Civic', 'RAV4', 'F-150', 'CR-V']) => {
  const [text, setText] = useState(fallback);
  useEffect(() => {
    if (reduce()) return undefined;
    let w = 0; let i = 0; let deleting = false; let pause = 0;
    const id = setInterval(() => {
      if (pause) { pause -= 1; return; }
      const word = words[w];
      i += deleting ? -1 : 1;
      setText(`Ex: ${word.slice(0, i)}${deleting || i < word.length ? '|' : ''}`);
      if (!deleting && i === word.length) { deleting = true; pause = 14; }
      else if (deleting && i === 0) { deleting = false; w = (w + 1) % words.length; pause = 3; }
    }, 90);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return text;
};
